"use client";
import { useEffect, useState, useRef } from "react";
import { Col, Input } from "reactstrap";
import PlaceSearch from "../../PlacesSearch";
import { useDispatch, useSelector } from "react-redux";
import {
  setBwvSearchQuery,
  setRadius,
  setSearchTerm,
  setSearchText,
  setSelectedBusinessDetails,
  setSelectedCat,
  setSelectedItem,
  setSelectedSubCat,
} from "../../../redux/slices/bwvSlice";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  RiArrowLeftSLine,
  RiFolderFill,
  RiHome4Fill,
  RiStoreFill,
  RiHeartFill,
  RiStarFill,
  RiCalendarFill,
  RiArrowDownDoubleFill,
  RiRecordCircleFill,
  RiSubtractLine,
  RiCarFill,
  RiCalendarCheckFill,
  RiAdvertisementFill,
  RiTShirtFill,
  RiPlayCircleFill,
  RiMicFill,
  RiUserLocationFill,
  RiTentFill,
  RiHeadphoneFill,
  RiProductHuntFill,
  RiTreasureMapFill,
  RiBrushFill,
  RiGovernmentFill,
  RiMusic2Fill,
  RiFootballFill,
  RiGamepadFill,
  RiWomenFill,
  RiMic2Fill,
  RiMovieFill,
  RiRestaurantFill,
  RiLiveFill,
} from "react-icons/ri";
import { setCurrentPage } from "../../../redux/slices/bwvSlice";
import "../../../../src/components/Layout/Prosidebar.css";
import Tooltip from "../../Layout/tooltip";
import SidebarLoading from "../../Layout/SidebarLoading";
import ZipcodeFilter from "./ZipcodeFilter";
import { resetImageData } from "../../../redux/slices/ImageSlice";
import BusinessFilter from "./BusinessFilter";
import { clearBusinessFilters } from "../../../redux/slices/CustomFieldsSlice";

const ANIMATION_DURATION = 300;

const getIconForCategory = (name) => {
  if (!name) return <RiFolderFill />;

  const nameLower = name.toLowerCase();
  if (nameLower.includes("photography")) {
    return <RiStarFill />;
  } else if (nameLower.includes("venue")) {
    return <RiHome4Fill />;
  } else if (nameLower.includes("catering") || nameLower.includes("cuisine")) {
    return <RiStoreFill />;
  } else if (nameLower.includes("decoration")) {
    return <RiHeartFill />;
  } else if (nameLower.includes("music")) {
    return <RiCalendarFill />;
  } else if (nameLower.includes("ads")) {
    return <RiAdvertisementFill />;
  } else if (nameLower.includes("clothing")) {
    return <RiTShirtFill />;
  } else if (nameLower.includes("transportation")) {
    return <RiCarFill />;
  } else if (nameLower.includes("dance")) {
    return <RiPlayCircleFill />;
  } else if (nameLower.includes("mc/host")) {
    return <RiMicFill />;
  } else if (nameLower.includes("turban")) {
    return <RiUserLocationFill />;
  } else if (nameLower.includes("tent")) {
    return <RiTentFill />;
  } else if (nameLower.includes("planning")) {
    return <RiCalendarCheckFill />;
  } else if (nameLower.includes("dj")) {
    return <RiHeadphoneFill />;
  } else if (nameLower.includes("gurudwara") || nameLower.includes("temple")) {
    return <RiGovernmentFill />;
  } else if (nameLower.includes("hair") || nameLower.includes("makeup")) {
    return <RiProductHuntFill />;
  } else if (nameLower.includes("jewelry")) {
    return <RiTreasureMapFill />;
  } else if (nameLower.includes("mehndi")) {
    return <RiBrushFill />;
  } else if (nameLower.includes("music") && nameLower.includes("concert")) {
    return <RiMusic2Fill />;
  } else if (nameLower.includes("sports") || nameLower.includes("event")) {
    return <RiFootballFill />;
  } else if (nameLower.includes("gaming") || nameLower.includes("esports")) {
    return <RiGamepadFill />;
  } else if (nameLower.includes("fashion") || nameLower.includes("lifestyle")) {
    return <RiWomenFill />;
  } else if (nameLower.includes("podcast") || nameLower.includes("talk show")) {
    return <RiMic2Fill />;
  } else if (nameLower.includes("cartoon") || nameLower.includes("animation")) {
    return <RiMovieFill />;
  } else if (nameLower.includes("cooking") || nameLower.includes("food")) {
    return <RiRestaurantFill />;
  } else if (nameLower.includes("live music")) {
    return <RiLiveFill />;

    // === Fallback ===
  } else {
    return <RiFolderFill />;
  }
};
const BwvSideBar = ({
  categories = [],
  subCategories = [],
  items = [],
  setScrollPopupVisible,
  collapsed,
  setCollapsed,
  toggled,
  setToggled,
  isMobileView,
  isTabletView,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { searchTerm, selectedCat, selectedSubCat, selectedItem } = useSelector(
    (state) => state.bwvData
  );
  const sidebarRef = useRef(null);
  const subMenuRefs = useRef({});
  const subCatRefs = useRef({});
  const firstSubMenuBtnRefs = useRef({});
  const popupRef = useRef();
  const [showPopup, setShowPopup] = useState(false);
  const [showRemainingCategories, setShowRemainingCategories] = useState(false);
  const [tempRadius, setTempRadius] = useState(0);
  const [openSubmenus, setOpenSubmenus] = useState(new Set());
  const [openSubCategories, setOpenSubCategories] = useState(new Set());
  const { currentPage, activeGridTab, radius } = useSelector(
    (state) => state.bwvData
  );
  const initialCategoriesToShow = 8;
  const safeCategories = Array.isArray(categories) ? categories : [];
  const safeSubCategories = Array.isArray(subCategories) ? subCategories : [];
  const safeItems = Array.isArray(items) ? items : [];
  const [visibleCategories, setVisibleCategories] = useState(
    safeCategories.slice(0, initialCategoriesToShow)
  );
  // Show loading if data is still being fetched
  const isDataLoading = safeCategories.length === 0;
  console.log(safeItems, "safeItems");
  const handlePopUpClick = () => {
    window.scrollTo(0, 0);
    if (setScrollPopupVisible) {
      setScrollPopupVisible(true);
    }
  };

  const handleCategoryClick = (category, e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(clearBusinessFilters());
    dispatch(setSelectedBusinessDetails(""));
    dispatch(resetImageData());
    if (!category) return;
    dispatch(setSearchText(""));
    dispatch(setBwvSearchQuery(""));
    dispatch(setRadius(15));
    dispatch(setCurrentPage(1));
    handlePopUpClick();
    if (category.Name === "Local Community Ads") {
      navigate("/Localcommunityads");
      return;
    }
    const searchParams = new URLSearchParams(location.search);
    const isCurrentlySelected = selectedCat && selectedCat.Id === category.Id;

    if (isCurrentlySelected) {
      dispatch(setSelectedCat(null));
      dispatch(setSelectedSubCat(null));
      dispatch(setSelectedItem(null));
      searchParams.delete("category");
      searchParams.delete("subcategory");
      searchParams.delete("item");
      searchParams.delete("categoryName");
      setOpenSubmenus((prev) => {
        const newSet = new Set(prev);
        newSet.delete(category.Id);
        return newSet;
      });
    } else {
      dispatch(setSelectedCat(category));
      dispatch(setSelectedSubCat(null));
      dispatch(setSelectedItem(null));
      searchParams.set("category", category.Name || "");
      searchParams.delete("subCategory");
      searchParams.delete("item");
      searchParams.delete("categoryName");
      setOpenSubmenus(new Set([category.Id]));
      setOpenSubCategories(new Set());
    }
    // searchParams.set("selected", "explorer");
    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: true }
    );

    if (isMobileView || isTabletView) {
      if (!toggled) {
        setToggled(true);
      }
    } else if (collapsed && !isCurrentlySelected) {
      setCollapsed(false);
    }
  };

  const handleSubCategoryClick = (subCategory, ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    dispatch(resetImageData());
    if (!subCategory) return;
    dispatch(setSearchText(""));
    dispatch(setBwvSearchQuery(""));
    dispatch(setCurrentPage(1));
    dispatch(setRadius(15));
    const searchParams = new URLSearchParams(location.search);
    const isCurrentlySelected =
      selectedSubCat && selectedSubCat.id === subCategory.id;

    if (isCurrentlySelected) {
      dispatch(setSelectedSubCat(null));
      dispatch(setSelectedItem(null));
      searchParams.delete("subCategory");
      searchParams.delete("item");
      searchParams.delete("categoryName");
      setOpenSubCategories((prev) => {
        const newSet = new Set(prev);
        newSet.delete(subCategory.id);
        return newSet;
      });
    } else {
      dispatch(setSelectedSubCat(subCategory));
      dispatch(setSelectedItem(null));
      searchParams.set("subCategory", subCategory.Name || "");
      searchParams.delete("item");
      searchParams.delete("categoryName");
      setOpenSubCategories(new Set([subCategory.id]));
    }

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: true }
    );
  };
  const handleItemClick = (item, ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    dispatch(resetImageData());
    if (!item) return;
    dispatch(setSearchText(""));
    dispatch(setBwvSearchQuery(""));
    dispatch(setCurrentPage(1));
    dispatch(setRadius(15));
    const searchParams = new URLSearchParams(location.search);
    const isCurrentlySelected =
      selectedItem && selectedItem.subCatItemId === item.subCatItemId;

    if (isCurrentlySelected) {
      dispatch(setSelectedItem(null));
      searchParams.delete("item");
      searchParams.delete("categoryName");
    } else {
      dispatch(setSelectedItem(item));
      searchParams.set("item", item.subCatItemName || "");
      searchParams.delete("categoryName");
    }

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString(),
      },
      { replace: true }
    );

    if (isMobileView) {
      tglHide();
    }
  };

  const handleCollapse = () => {
    setCollapsed((prev) => !prev);
    if (!collapsed) {
      // Close all submenus when collapsing
      setOpenSubmenus(new Set());
      setOpenSubCategories(new Set());
      Object.values(firstSubMenuBtnRefs.current).forEach((element) => {
        if (element && element.parentElement) {
          element.parentElement.classList.remove("psb-open", "sidebar-open");
        }
      });
    }
  };

  const tglHide = () => {
    const hdel = document.getElementById("bwv-sidebar");
    if (hdel) {
      hdel.classList.remove("tgl-show");
      hdel.classList.add("has-close");
    }
    setToggled(false);
  };

  const filterByLocation = () => {
    tglHide();
  };

  const handleRadiusChange = (event) => {
    dispatch(resetImageData());
    const newRadius = Number.parseInt(event.target.value, 10);
    if (!isNaN(newRadius)) {
      setTempRadius(newRadius);
    }
  };

  const handleRadiusCommit = () => {
    if (tempRadius >= 0) {
      dispatch(resetImageData());
      dispatch(setRadius(tempRadius));
      dispatch(setCurrentPage(1));
    }
  };

  // Initialize URL state on mount
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categoryName = searchParams.get("category");
    const subCategoryName = searchParams.get("subCategory");
    const itemName = searchParams.get("item");

    // Initialize category
    if (categoryName && safeCategories.length > 0) {
      const matchingCategory = safeCategories.find(
        (category) =>
          category &&
          category.Name &&
          category.Name.toLowerCase() === categoryName.toLowerCase()
      );
      if (matchingCategory) {
        dispatch(setSelectedCat(matchingCategory));
        setOpenSubmenus(new Set([matchingCategory.Id]));
      } else {
        console.warn("Invalid categoryName:", categoryName);
        searchParams.delete("category");
        navigate(
          { pathname: location.pathname, search: searchParams.toString() },
          { replace: true }
        );
      }
    } else {
      dispatch(setSelectedCat(null));
      setOpenSubmenus(new Set());
    }

    // Initialize subcategory
    if (subCategoryName && safeSubCategories.length > 0) {
      const matchingSubCategory = safeSubCategories.find(
        (subCat) =>
          subCat &&
          subCat.Name &&
          subCat.Name.toLowerCase() === subCategoryName.toLowerCase()
      );
      if (matchingSubCategory) {
        dispatch(setSelectedSubCat(matchingSubCategory));
        setOpenSubCategories(new Set([matchingSubCategory.id]));
      } else {
        console.warn("Invalid subCategoryName:", subCategoryName);
        searchParams.delete("subCategory");
        navigate(
          { pathname: location.pathname, search: searchParams.toString() },
          { replace: true }
        );
      }
    } else {
      dispatch(setSelectedSubCat(null));
      setOpenSubCategories(new Set());
    }

    // Initialize item
    if (itemName && safeItems.length > 0) {
      const matchingItem = safeItems.find(
        (item) =>
          item &&
          item.subCatItemName &&
          item.subCatItemName.toLowerCase() === itemName.toLowerCase()
      );
      if (matchingItem) {
        dispatch(setSelectedItem(matchingItem));
      } else {
        console.warn("Invalid itemName:", itemName);
        searchParams.delete("item");
        navigate(
          { pathname: location.pathname, search: searchParams.toString() },
          { replace: true }
        );
      }
    } else {
      dispatch(setSelectedItem(null));
    }
  }, [
    location.search,
    safeCategories,
    safeSubCategories,
    safeItems,
    dispatch,
    navigate,
  ]);
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const categoryName = searchParams.get("category");
    const subCategoryName = searchParams.get("subCategory");
    if (!categoryName && !subCategoryName) {
      dispatch(setSelectedCat(null));
      dispatch(setSelectedSubCat(null));
      dispatch(setSelectedItem(null));
      setOpenSubmenus(new Set());
      setOpenSubCategories(new Set());
    }
  }, [location.search, dispatch]);
  // Handle submenu visibility based on selected category
  useEffect(() => {
    if (selectedCat && subMenuRefs.current[selectedCat.Id]) {
      const submenuElement = subMenuRefs.current[selectedCat.Id];
      if (!openSubmenus.has(selectedCat.Id)) {
        setOpenSubmenus((prev) => new Set([...prev, selectedCat.Id]));
        // slideDown(submenuElement);
      }
    }
  }, [selectedCat, openSubmenus]);

  // Handle subcategory submenu visibility
  useEffect(() => {
    if (selectedSubCat && subCatRefs.current[selectedSubCat.id]) {
      const subCatElement = subCatRefs.current[selectedSubCat.id];
      if (!openSubCategories.has(selectedSubCat.id)) {
        setOpenSubCategories((prev) => new Set([...prev, selectedSubCat.id]));
        // slideDown(subCatElement);
      }
    }
  }, [selectedSubCat, openSubCategories]);

  useEffect(() => {
    setTempRadius(radius);
  }, [radius]);

  useEffect(() => {
    setVisibleCategories(
      safeCategories.slice(
        0,
        showRemainingCategories
          ? safeCategories.length
          : initialCategoriesToShow
      )
    );
  }, [safeCategories, showRemainingCategories]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (isMobileView || isTabletView) &&
        toggled &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest(".psb-mobile-trigger")
      ) {
        setToggled(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [toggled, isMobileView, isTabletView, setToggled]);

  const Popup = ({ closePopup }) => (
    <div
      className="text-center wc_show_cat_popup d-lg-none d-xl-block d-none"
      style={{ position: "absolute", top: "10px", left: "140px" }}
    >
      <div
        ref={popupRef}
        style={{
          padding: "10px",
          backgroundColor: "var(--theme-light)",
          borderRadius: "8px",
          boxShadow: "0 4px 8px var(--theme-shadow)",
          color: "var(--white)",
          zIndex: 999,
          width: 120,
          display: "flex",
          flexDirection: "row",
          animation: "flashingColor 2s infinite",
        }}
      >
        <div
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            textWrap: "nowrap",
          }}
        >
          Select to view
        </div>
        <div
          style={{
            marginTop: "-5px",
            textAlign: "center",
          }}
          onClick={closePopup}
        >
          <RiArrowDownDoubleFill size={20} />
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const timer = setTimeout(() => setShowPopup(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };
    if (showPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showPopup]);

  return (
    <aside
      id="bwv-sidebar"
      className={`psb-sidebar psb-has-bg-image fw-bold ${
        collapsed && !isMobileView && !isTabletView
          ? "psb-collapsed-desktop"
          : ""
      } ${toggled ? "psb-toggled" : ""}`}
      ref={sidebarRef}
    >
      <div className="psb-layout px-4 pb-5">
        <div className="psb-content">
          {(isMobileView || isTabletView) && toggled && (
            <div
              className="psb-mobile-close-btn text-2xl p-1 cursor-pointer"
              onClick={() => setToggled(false)}
            >
              <RiArrowLeftSLine />
            </div>
          )}
          <nav className="psb-menu psb-open-current-submenu">
            {isDataLoading ? (
              <SidebarLoading
                collapsed={collapsed}
                isMobileView={isMobileView}
                isTabletView={isTabletView}
                toggled={toggled}
                itemCount={8}
              />
            ) : (
              <ul>
                <li className="psb-menu-header">
                  <span className="sidebar-header-text">WEDDING VENDORS</span>
                </li>
                {visibleCategories.map((category) => {
                  if (!category) return null;
                  const isSelected =
                    selectedCat && selectedCat.Name === category.Name;
                  const isOpen = isSelected;

                  return (
                    <li
                      key={category.Id}
                      className={`sidebar-item submenu ${
                        isSelected ? "sidebar-item-active sidebar-open" : ""
                      }`}
                      onClick={(e) => handleCategoryClick(category, e)}
                      style={{
                        listStyle: "none",
                        backgroundColor: isSelected ? "whitesmoke" : "",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      <Tooltip
                        text={category.Name || "Unnamed Category"}
                        visible={
                          (collapsed && !toggled && !isMobileView) ||
                          (isTabletView && !toggled)
                        }
                      >
                        <div
                          className={`sidebar-link-content ${
                            collapsed ? "" : " "
                          }`}
                          ref={(el) =>
                            (firstSubMenuBtnRefs.current[category.Id] = el)
                          }
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding:
                              (collapsed && !isMobileView && !isTabletView) ||
                              (isTabletView && !toggled)
                                ? "15px 8px"
                                : "10px 15px",
                            color: isSelected
                              ? "var(--button-bg)"
                              : "var(--text-primary)",
                            fontSize: "medium",
                            textDecoration: "none",
                            fontWeight: 600,
                            transition: "all 0.5s ease",
                            borderRadius: "5px",
                            justifyContent: !collapsed
                              ? "flex-start"
                              : "center",
                            width: "100%",
                            minHeight: "40px",
                          }}
                        >
                          <span
                            className="sidebar-icon"
                            style={{
                              display: "inline-block",
                              color: isSelected
                                ? "var(--button-bg)"
                                : "var(--text-primary)",
                              transition: "all 0.3s ease",
                            }}
                          >
                            {getIconForCategory(category.Name)}
                          </span>
                          <span
                            className="sidebar-title mt-1"
                            style={{
                              marginLeft:
                                (collapsed && !isMobileView && !isTabletView) ||
                                (isTabletView && !toggled)
                                  ? "0px"
                                  : "10px",
                              color: isSelected
                                ? "var(--button-bg)"
                                : "var(--text-primary)",
                              transition: "color 0.5s ease",
                              display:
                                (collapsed && !isMobileView && !isTabletView) ||
                                (isTabletView && !toggled)
                                  ? "none"
                                  : "inline",
                            }}
                          >
                            {category.Name || "Unnamed Category"}
                          </span>
                        </div>
                      </Tooltip>
                      <div
                        className="submenu-list"
                        ref={(el) => (subMenuRefs.current[category.Id] = el)}
                        style={{
                          display:
                            isSelected && !collapsed && isOpen
                              ? "block"
                              : "none",
                          paddingRight: "8px",
                          overflow: "hidden",
                          transition: "all 0.5s ease",
                        }}
                      >
                        <ul style={{ padding: 0, margin: 0 }}>
                          {safeSubCategories
                            .filter(
                              (subCategory) =>
                                subCategory &&
                                subCategory.CategoryId === category.Id
                            )
                            .map((subCategory) => {
                              const isSubCatSelected =
                                selectedSubCat &&
                                selectedSubCat.Name === subCategory.Name;
                              const isSubCatOpen = isSubCatSelected;

                              return (
                                <li
                                  key={subCategory.id}
                                  className={`submenu-item ${
                                    isSubCatSelected
                                      ? "submenu-item-active"
                                      : ""
                                  }`}
                                  onClick={(ev) =>
                                    handleSubCategoryClick(subCategory, ev)
                                  }
                                  style={{
                                    listStyle: "none",
                                    padding: "8px 0px 8px 15px",
                                    color: isSubCatSelected
                                      ? "var(--beige-bg)"
                                      : "var(--text-primary)",
                                    cursor: "pointer",
                                    borderRadius: "4px",
                                    fontSize: "15px",
                                    fontWeight: 600,
                                    transition: "all 0.3s ease",
                                    minHeight: "32px",
                                  }}
                                >
                                  <div
                                    style={{
                                      textDecoration: "none",
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                    }}
                                  >
                                    <RiRecordCircleFill
                                      size={8}
                                      color={
                                        isSubCatSelected
                                          ? "var(--button-bg)"
                                          : "var(--text-primary)"
                                      }
                                    />
                                    <span
                                      className="submenu-title"
                                      style={{
                                        color: isSubCatSelected
                                          ? "var(--button-bg)"
                                          : "var(--text-primary)",
                                        transition: "color 0.5s ease",
                                        fontSize: "14px",
                                      }}
                                    >
                                      {subCategory.Name ||
                                        "Unnamed Subcategory"}
                                    </span>
                                  </div>
                                  <div
                                    className="submenu-list"
                                    ref={(el) =>
                                      (subCatRefs.current[subCategory.id] = el)
                                    }
                                    style={{
                                      display:
                                        isSubCatSelected && isSubCatOpen
                                          ? "block"
                                          : "none",
                                      overflow: "hidden",
                                      transition: "all 0.5s ease",
                                    }}
                                  >
                                    <ul style={{ padding: 0, margin: 0 }}>
                                      {safeItems
                                        .filter(
                                          (item) =>
                                            item &&
                                            item.subCatId === subCategory.id
                                        )
                                        .map((item) => {
                                          const isItemSelected =
                                            selectedItem &&
                                            selectedItem.subCatItemName ===
                                              item.subCatItemName;

                                          return (
                                            <li
                                              key={item.subCatItemId}
                                              className={`submenu-item ${
                                                isItemSelected
                                                  ? "submenu-item-active"
                                                  : ""
                                              }`}
                                              onClick={(ev) =>
                                                handleItemClick(item, ev)
                                              }
                                              style={{
                                                listStyle: "none",
                                                padding: "8px 0px 8px 15px",
                                                color: isItemSelected
                                                  ? "var(--white)"
                                                  : "var(--text-primary)",
                                                cursor: "pointer",
                                                backgroundColor: isItemSelected
                                                  ? "var(--button-bg)"
                                                  : "transparent",
                                                borderRadius: "4px",
                                                fontSize: "14px",
                                                fontWeight: 600,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "5px",
                                                transition: "all 0.3s ease",
                                                minHeight: "28px",
                                              }}
                                            >
                                              <RiSubtractLine
                                                size={14}
                                                color={
                                                  isItemSelected
                                                    ? "var(--white)"
                                                    : "var(--text-primary)"
                                                }
                                              />
                                              <span
                                                className="sidebar-title"
                                                style={{
                                                  color: isItemSelected
                                                    ? "var(--white)"
                                                    : "var(--text-primary)",
                                                  transition: "color 0.5s ease",
                                                }}
                                              >
                                                {item.subCatItemName ||
                                                  "Unnamed Item"}
                                              </span>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </li>
                  );
                })}
                {!showRemainingCategories &&
                  safeCategories.length > initialCategoriesToShow && (
                    <li
                      className="show-more"
                      onClick={() => setShowRemainingCategories(true)}
                      style={{
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <div
                        style={{
                          display:
                            collapsed || (isTabletView && !toggled)
                              ? "none"
                              : "flex",
                          justifyContent: "flex-end",
                          padding: "10px 15px",
                          color: "var(--text-secondary)",
                          fontSize: "medium",
                          textDecoration: "none",
                          fontWeight: 600,
                          transition: "all 0.5s ease",
                          borderRadius: "5px",
                          minHeight: "40px",
                          alignItems: "center",
                        }}
                      >
                        <span
                          className="mt-1"
                          style={{
                            color: "var(--text-tertiary)",
                            transition: "color 0.5s ease",
                          }}
                        >
                          Show More
                        </span>
                      </div>
                    </li>
                  )}
                {showRemainingCategories && (
                  <li
                    className="show-more"
                    onClick={() => setShowRemainingCategories(false)}
                    style={{
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        display:
                          collapsed || (isTabletView && !toggled)
                            ? "none"
                            : "flex",
                        justifyContent: "flex-end",
                        padding: "10px 15px",
                        color: "var(--text-secondary)",
                        fontSize: "medium",
                        textDecoration: "none",
                        fontWeight: 600,
                        transition: "all 0.5s ease",
                        borderRadius: "5px",
                        minHeight: "40px",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className="mt-1"
                        style={{
                          color: "var(--text-tertiary)",
                          transition: "color 0.5s ease",
                        }}
                      >
                        Show Less
                      </span>
                    </div>
                  </li>
                )}
                <BusinessFilter selectedCat={selectedCat} />
                <ZipcodeFilter
                  collapsed={collapsed}
                  searchTerm={searchTerm}
                  setRadius={setRadius}
                  setSearchTerm={setSearchTerm}
                  tglHide={tglHide}
                  isTabletView={isTabletView}
                  toggled={toggled}
                  tempRadius={tempRadius}
                  handleRadiusChange={handleRadiusChange}
                  handleRadiusCommit={handleRadiusCommit}
                  type="bwv"
                />
              </ul>
            )}
          </nav>
          {showPopup && <Popup closePopup={() => setShowPopup(false)} />}
        </div>
      </div>
      {!isMobileView && !isTabletView && (
        <a
          id="psb-btn-collapse"
          className="psb-collapser"
          onClick={handleCollapse}
        >
          <RiArrowLeftSLine />
        </a>
      )}
    </aside>
  );
};

export default BwvSideBar;
